import { ChevronLeftIcon } from '@chakra-ui/icons';
import { Link as ChakraLink } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

import { useSetSelectedPlaylistIdValue } from '~/store/slices/playlist-hook';

export default function GoBackButton() {
  const { t } = useTranslation(['common']);
  const setSelectedPlaylistIdValue = useSetSelectedPlaylistIdValue();

  return (
    <ChakraLink
      position='absolute'
      left={4}
      color='black'
      display='flex'
      fontSize='14px'
      alignItems='center'
      justifyContent='flex-start'
      fontFamily='body'
      onClick={() => setSelectedPlaylistIdValue(null)}
    >
      <ChevronLeftIcon w={4} h={4} />
      {t('actions.return')}
    </ChakraLink>
  );
}
